import React, { useEffect, useState } from 'react'
import styles from './style/input_number_style.module.scss';
import PropTypes from 'prop-types';
import { IconMap } from '../../foundations/icon/Icon'
import Translation from '../../../global/Translation'
import IconButton from '../../basics/icon-button/IconButton'
import { FOUNDATION_PROPTYPES } from '../../foundations/Foundation'
import UpDownButton from '../../basics/up-down-button/UpDownButton'
import Typography from '../../foundations/typography/Typography'

const InputNumber = ({ children, onClick, className = '', disabled, ...props }) => {
    const [value, setValue] = useState(props.valueDefault ? props.valueDefault : props.min)
    const [min, setMin] = useState(props.min ? props.min : 0)
    const [max, setMax] = useState(props.max ? props.max : 999)

    useEffect(() => {
        setMin(props.min ? props.min : 0)
    }, [min]);

    useEffect(() => {
        setMax(props.max ? props.max : 999)
    }, [max]);

    const upNumber = () => {
        if(!isDisabled() && value < max){
            let _value = value
            if (_value === '') _value = min
            else _value += 1
            setValue(_value)
            if (typeof props.onChangeValue === "function") props.onChangeValue(_value)
        }
    }

    const downNumber = () => {
        if(!isDisabled() && value > min){
            let _value = value
            if (_value === '') _value = min
            else _value -= 1
            setValue(_value)
            if (typeof props.onChangeValue === "function") props.onChangeValue(_value)
        }
    }

    const handleChangeValue = (e) => {
        let _value = e.target.value === '' ? '' : parseInt(e.target.value)
        if (_value === '') {
            setValue('')
            if (typeof props.onChangeValue === "function") props.onChangeValue(props.min)
        } else if(!isNaN(_value)) {
            _value = Math.max(min, _value)
            _value = Math.min(max, _value)
            setValue(_value)
            if (typeof props.onChangeValue === "function") props.onChangeValue(_value)
        }
    }

    const handleBlur = () => {
        if (value === '') setValue(min)
    }

    const isDisabled = () => props.disabled ? true : (max <= min)


    return (
        <div className={styles['input-number']}>
            <div className={styles['input-number-input']}>
                <UpDownButton onClickUp={upNumber}
                              onClickDown={downNumber}
                              iconSize={16}
                              secondary
                />
                <Typography className={styles['input-number-text-input']} typeface="body-m-medium" secondary>
                    <input
                        maxLength="3"
                        value={value}
                        onChange={handleChangeValue}
                        onBlur={handleBlur}
                        disabled={disabled}
                    />
                </Typography>
            </div>

            {max && (
                <Typography className={styles['input-number-max']} typeface="body-s-regular" secondary>
                    <Translation id="of" defaultMessage="of" /> {max}
                </Typography>
            )}
        </div>
    )
}

const ICON_BUTTON_PROPTYPES = {
    ...FOUNDATION_PROPTYPES,
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    img:  PropTypes.oneOf(Object.keys(IconMap)).isRequired,
    hImg:  PropTypes.oneOf(Object.keys(IconMap)),
};

IconButton.propTypes = ICON_BUTTON_PROPTYPES


export default InputNumber;
